import { FC } from 'react';
import { useParams } from 'react-router-dom';

import { RiderAssistantPresenter } from './RiderAssistantPresenter';
import { useRiderAssistantDetailsQuery } from './useRiderAssistantDetailsQuery';
import { useRiderAssistantOnRideQuery } from './useRiderAssistantOnRideQuery';

interface RiderAssistantDetailsProps {
  adminRideUrl?: string;
  riderAssistantId: string;
}

export const RiderAssistantDetails: FC<RiderAssistantDetailsProps> = ({ adminRideUrl, riderAssistantId }) => {
  const { rideSlug } = useParams<{ rideSlug?: string }>();
  const { data: riderDetailsResult, isFetching } = useRiderAssistantOnRideQuery({ rideSlug: rideSlug || '' });

  return (
    <RiderAssistantPresenter
      riderDetails={riderDetailsResult?.data}
      isFetching={isFetching}
      adminRideUrl={adminRideUrl}
      riderAssistantId={riderAssistantId}
    />
  );
};

export const RemovedRiderAssistantDetails: FC<RiderAssistantDetailsProps> = ({ adminRideUrl, riderAssistantId }) => {
  const { data: riderDetailsResult, isFetching } = useRiderAssistantDetailsQuery({
    riderAssistantId: riderAssistantId,
  });

  return (
    <RiderAssistantPresenter
      riderDetails={riderDetailsResult?.data}
      isFetching={isFetching}
      adminRideUrl={adminRideUrl}
      riderAssistantId={riderAssistantId}
      isRemovedRider={true}
    />
  );
};
